module.exports = __webpack_public_path__ + "static/icons/icon-12-day-381b6d522f0ed5cd8d6d40a25983c48c.svg";